<template>
  <div class="w-full min-w-full pt-[90px]">
    <div id="home"><Hero /></div>
    <div id="how-it-works"><HowItWorks /></div>
    <UnlockThePotential />
    <EnableInteractivity />
    <ElevateAIExperiences />
    <div id="pricing"><Pricing /></div>
  </div>
</template>

<script>
import Hero from "../components/Home/Hero.vue";
import HowItWorks from "../components/Home/HowItWorks.vue";
import UnlockThePotential from "../components/Home/UnlockThePotential.vue";
import EnableInteractivity from "../components/Home/EnableInteractivity.vue";
import ElevateAIExperiences from "../components/Home/ElevateAIExperiences.vue";
import Pricing from "../components/Home/Pricing.vue";

export default {
  components: {
    Hero,
    HowItWorks,
    UnlockThePotential,
    EnableInteractivity,
    ElevateAIExperiences,
    Pricing
  },
  data() {
    return {
      scrollTop: !import.meta.env.SSR ? window.scrollY : 0,
      windowWidth: !import.meta.env.SSR ? window.innerWidth : 1536,
      windowHeight: !import.meta.env.SSR ? window.innerHeight : 864,
    };
  },
  mounted() {
    window.addEventListener("scroll", this.handleScroll, true);
    window.addEventListener("resize", this.handleResize, true);
    this.handleScroll();
    this.handleResize();
  },
  beforeUnmount() {
    window.removeEventListener("scroll", this.handleScroll, true);
    window.removeEventListener("resize", this.handleResize, true);
  },
  methods: {
    handleScroll() {
      this.scrollTop = window.scrollY;
    },
    handleResize() {
      this.windowWidth = window.innerWidth;
      this.windowHeight = window.innerHeight;
    },
  },
};
</script>
